import { StreamTimeSeriesState } from 'widgets/store/stream/WidgetStreamState';
import { StreamDisableRangeDataState } from 'widgets/store/disableRange/StreamDisableRangeDataState';
import {
    StreamsByStreamKeyState,
    StreamState,
} from 'streamsState/store/streamedData/StreamedDataState';
import { KeyedStreamItem } from 'communication/types/StreamElement';

export interface PriceTimeDataTimeSeriesItem extends KeyedStreamItem {
    open: number;
    high: number;
    low: number;
    close: number;
    volume: number;
}

export interface PriceStreamDataState
    extends StreamTimeSeriesState<PriceTimeDataTimeSeriesItem>,
        StreamDisableRangeDataState {
    orderStat?: {
        previousNightClose: number;
        exchangeRate: number;
        tickSize?: number;
    };
}

export type PriceStreamState = StreamState<PriceStreamDataState>;
export type PriceStreamsState = StreamsByStreamKeyState<PriceStreamDataState>;

export const initialPriceStreamsState: PriceStreamsState = {};

export const initialPriceStreamDataState: PriceStreamDataState = {
    timeSeries: [],
    disableRange: [],
};

export const initialPriceStreamState: PriceStreamState = {
    messages: [],
    data: initialPriceStreamDataState,
};
